import React, { useEffect } from 'react';
import './App.css';
import HomePage from './pages/HomePage';

function App() {
  // Ajout du CDN Tailwind
  useEffect(() => {
    // Création d'un élément link pour le Tailwind CSS via CDN
    const tailwindCDN = document.createElement('link');
    tailwindCDN.rel = 'stylesheet';
    tailwindCDN.href = 'https://cdn.tailwindcss.com';
    document.head.appendChild(tailwindCDN);

    // Nettoyage à la destruction du composant
    return () => {
      document.head.removeChild(tailwindCDN);
    };
  }, []);

  return (
    <div className="App">
      <HomePage />
    </div>
  );
}

export default App;
